/**
 * Token and profile storage for MobileRedirection flows (get-started → manage-dashboard).
 */

export const MOBILE_PRO_DATA_KEY = "mobileRedirectionProData";
export const MOBILE_PRO_TOKEN_KEY = "professionalTokenMobileRedirection";

const parseStoredToken = (raw) => {
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
};

export const getMobileRedirectionAuthToken = () =>
  parseStoredToken(localStorage.getItem(MOBILE_PRO_TOKEN_KEY));

/** Mobile redirection token, or standard web `professionalToken`. */
export const getProfessionalAuthToken = () => {
  const mobileToken = getMobileRedirectionAuthToken();
  if (mobileToken) {
    return mobileToken;
  }
  return parseStoredToken(localStorage.getItem("professionalToken"));
};

export const syncMobileRedirectionSession = (profile) => {
  if (!profile) {
    return;
  }

  localStorage.setItem(MOBILE_PRO_DATA_KEY, JSON.stringify(profile));

  const accessToken = profile.accessToken;
  if (accessToken) {
    localStorage.setItem(
      MOBILE_PRO_TOKEN_KEY,
      JSON.stringify(accessToken)
    );
  }
};

export const hasMobileRedirectionSession = () =>
  Boolean(getMobileRedirectionAuthToken());
